module.exports = __webpack_public_path__ + "img/IM-02.817bd300.jpg";